module.exports = __webpack_public_path__ + "media/music/e27f7cdf42df8b768345ae83fecffe4b.mp3";